import React, { FC, useEffect, useMemo } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { Layout, Spinner } from '../../components';
import { auth, filterMenuByAdminPermission, menu } from '../../config';
import { usePermissions } from '../../hooks';
import { useAuthState } from '../../state';
import { MenuItemProps } from '../../types';

export const ProtectedRoute: FC = () => {
  const navigate = useNavigate();
  const { currentUser, isLoading } = useAuthState();
  const { adminPermission } = usePermissions();

  // Admin z zawężeniem (`onlyAttraction` / `onlySupport`) widzi tylko swoje zakładki.
  const visibleMenu = useMemo(
    () => filterMenuByAdminPermission(menu, adminPermission),
    [adminPermission],
  );

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        navigate('/login');
      }
    });

    return () => {
      unsubscribe();
    };
  }, [navigate]);

  if (isLoading) {
    return <Spinner global />;
  }

  if (currentUser) {
    return (
      <Layout menuConfig={visibleMenu as MenuItemProps[]}>
        <Outlet />
      </Layout>
    );
  }

  return null;
};
